import { SvgIcon, SvgIconProps } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfTwitterCommentsIconProps extends SvgIconProps {}
/**
 * component used to display twitter comments icon in twitter interaction
 * @param props - CcfTwitterCommentsIconProps
 * @example - <CcfTwitterCommentsIcon />
 * @returns SVG of twitter comments icon in twitter interaction
 */
export function CcfTwitterCommentsIcon(props: CcfTwitterCommentsIconProps) {
  return (
    <SvgIcon {...props}>
      <g id="ic_comments" clip-path="url(#clip-ic_comments)">
        <path id="Path_25523" data-name="Path 25523" d="M676.26,1250.7h0l-2.73-.006h0a5.08,5.08,0,0,0-5.135,5.135,4.875,4.875,0,0,0,4.915,4.851v2.52a.569.569,0,0,0,.077.266.492.492,0,0,0,.417.228.487.487,0,0,0,.265-.078c.173-.11,4.26-2.724,5.324-3.624a5.557,5.557,0,0,0,2-4.154v-.011A5.079,5.079,0,0,0,676.26,1250.7Zm2.493,8.539c-.747.632-3.2,2.241-4.458,3.056v-2.1a.494.494,0,0,0-.494-.494h-.261a3.892,3.892,0,0,1-4.159-3.874,4.1,4.1,0,0,1,4.147-4.148l2.729.007h0a4.1,4.1,0,0,1,4.148,4.144A4.565,4.565,0,0,1,678.753,1259.244Z" transform="translate(-666.893 -1249.199)" />
      </g>
    </SvgIcon>
  );
}

export default CcfTwitterCommentsIcon;
